(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["OS2-0_front_foldout"] && !Shopify.designMode) return;
  try {
    
$(".Linklist__content").on('click', function(e) {
	e.preventDefault();
	$(this).parent().toggleClass("Linklist__item--opened");
	$(this).parent().toggleClass("Linklist__item--closed");
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["front_foldout--dame"] && !Shopify.designMode) return;
  try {
    
$(".Linklist__content").on('click', function(e) {
	e.preventDefault();
	$(this).parent().toggleClass("Linklist__item--opened");
	$(this).parent().toggleClass("Linklist__item--closed");
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["front_foldout"] && !Shopify.designMode) return;
  try {
    
$(".Linklist__content").on('click', function(e) {
	e.preventDefault();
	$(this).parent().toggleClass("Linklist__item--opened");
	$(this).parent().toggleClass("Linklist__item--closed");
});

  } catch(e) { console.error(e); }
})();
})();
